import React from 'react';

export const Footer: React.FC = () => {
  const handleWhatsAppClick = () => {
    // Rastreamento Meta Pixel
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'Contact', {
        content_name: 'WhatsApp Footer',
        content_category: 'Button Click'
      });
    }
    
    window.open('https://wa.me/5585987894357?text=Olá! Gostaria de solicitar um orçamento para estamparia digital.', '_blank');
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 lg:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 md:mb-5" style={{ fontFamily: '"Agrandir Grand", sans-serif' }}>
              GMX Estamparia Digital Fortaleza
            </h3>
            <p className="text-sm sm:text-base md:text-lg text-gray-300 mb-5 md:mb-6 leading-relaxed">
              Estamparia digital de alta performance com qualidade superior e entrega rápida.
            </p>
            <div className="flex space-x-4 md:space-x-5">
              <a href="https://instagram.com/gmxfortaleza" target="_blank" rel="nofollow" className="w-10 h-10 md:w-12 md:h-12 bg-gray-800 hover:bg-purple-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl md:text-2xl"></i>
              </a>
              <a href="https://facebook.com/gmxfortaleza" target="_blank" rel="nofollow" className="w-10 h-10 md:w-12 md:h-12 bg-gray-800 hover:bg-purple-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl md:text-2xl"></i>
              </a>
              <button onClick={handleWhatsAppClick} className="w-10 h-10 md:w-12 md:h-12 bg-gray-800 hover:bg-green-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-whatsapp-fill text-xl md:text-2xl"></i>
              </button>
            </div>
          </div>
          
          <div>
            <h4 className="font-bold mb-4 md:mb-5 text-base sm:text-lg md:text-xl">Serviços</h4>
            <ul className="space-y-2 md:space-y-3 text-gray-300 text-sm sm:text-base md:text-lg">
              <li className="hover:text-white transition-colors cursor-pointer">Impressão Digital</li>
              <li className="hover:text-white transition-colors cursor-pointer">Estampas Exclusivas</li>
              <li className="hover:text-white transition-colors cursor-pointer">Amostras Rápidas</li>
              <li className="hover:text-white transition-colors cursor-pointer">Entrega Expressa</li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4 md:mb-5 text-base sm:text-lg md:text-xl">Contato</h4>
            <div className="space-y-3 md:space-y-4 text-gray-300 text-sm sm:text-base md:text-lg">
              <p className="flex items-start hover:text-white transition-colors">
                <i className="ri-map-pin-fill mr-2 md:mr-3 mt-1 flex-shrink-0 text-lg"></i>
                <span>Rua Senador Pompeu 2379, Fortaleza, CE</span>
              </p>
              <p className="flex items-center hover:text-white transition-colors cursor-pointer">
                <i className="ri-phone-fill mr-2 md:mr-3 flex-shrink-0 text-lg"></i>
                <span>(85) 8765-5550</span>
              </p>
              <p className="flex items-start hover:text-white transition-colors break-all">
                <i className="ri-mail-fill mr-2 md:mr-3 mt-1 flex-shrink-0 text-lg"></i>
                <span>gmxdigital.adm@gmail.com</span>
              </p>
            </div>
          </div>
          
          <div>
            <h4 className="font-bold mb-4 md:mb-5 text-base sm:text-lg md:text-xl">Horário de Funcionamento</h4>
            <div className="space-y-2 md:space-y-3 text-gray-300 text-sm sm:text-base md:text-lg">
              <p className="flex items-center">
                <i className="ri-time-fill mr-2 md:mr-3 flex-shrink-0 text-lg"></i>
                <span>Segunda a Sexta</span>
              </p>
              <p className="font-semibold text-white ml-7 md:ml-8">8h às 17h</p>
              <p className="flex items-center mt-3 md:mt-4">
                <i className="ri-close-circle-fill mr-2 md:mr-3 flex-shrink-0 text-lg"></i>
                <span>Sábado e Domingo</span>
              </p>
              <p className="font-semibold text-white ml-7 md:ml-8">Fechado</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
